"use client";

import {
  WEBSITE_COOKIES_URL,
  WEBSITE_IMPRINT_URL,
  WEBSITE_PRIVACY_POLICY_URL,
  WEBSITE_TERMS_URL,
  WEBSITE_WITHDRAWAL_URL,
} from "@calcom/lib/constants";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import Link from "next/link";

export function LegalFooter() {
  const { t } = useLocale();

  return (
    <nav className="text-subtle flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs">
      <Link href={WEBSITE_TERMS_URL} className="hover:text-emphasis hover:underline" target="_blank">
        {t("terms")}
      </Link>
      <Link href={WEBSITE_PRIVACY_POLICY_URL} className="hover:text-emphasis hover:underline" target="_blank">
        {t("privacy_policy")}
      </Link>
      <Link href={WEBSITE_IMPRINT_URL} className="hover:text-emphasis hover:underline" target="_blank">
        {t("imprint")}
      </Link>
      <Link href={WEBSITE_WITHDRAWAL_URL} className="hover:text-emphasis hover:underline" target="_blank">
        {t("withdrawal")}
      </Link>
      <Link href={WEBSITE_COOKIES_URL} className="hover:text-emphasis hover:underline" target="_blank">
        {t("cookies")}
      </Link>
    </nav>
  );
}
